function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { ComboBox, Item, Picker, Section } from '@deephaven/components';
import { StringCondition, DateCondition, getLabelForNumberCondition, getLabelForDateCondition, getLabelForStringCondition, NumberCondition, getDefaultConditionForType, getLabelForBooleanCondition, BooleanCondition, CharCondition, getLabelForCharCondition, isDateConditionValid, getDefaultValueForType } from "./ConditionalFormattingUtils.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('ConditionEditor');
var DEFAULT_CALLBACK = () => undefined;
var VALUE_PREFIX = 'value-';
var COLUMN_PREFIX = 'column-';
var numberValueConditions = [NumberCondition.IS_EQUAL, NumberCondition.IS_NOT_EQUAL, NumberCondition.IS_BETWEEN, NumberCondition.GREATER_THAN, NumberCondition.GREATER_THAN_OR_EQUAL, NumberCondition.LESS_THAN, NumberCondition.LESS_THAN_OR_EQUAL, NumberCondition.IS_NULL, NumberCondition.IS_NOT_NULL];
var numberColumnConditions = [NumberCondition.IS_EQUAL, NumberCondition.IS_NOT_EQUAL, NumberCondition.GREATER_THAN, NumberCondition.GREATER_THAN_OR_EQUAL, NumberCondition.LESS_THAN, NumberCondition.LESS_THAN_OR_EQUAL];
var stringValueConditions = [StringCondition.IS_EXACTLY, StringCondition.IS_NOT_EXACTLY, StringCondition.CONTAINS, StringCondition.DOES_NOT_CONTAIN, StringCondition.STARTS_WITH, StringCondition.ENDS_WITH, StringCondition.IS_NULL, StringCondition.IS_NOT_NULL];
var stringColumnConditions = [StringCondition.IS_EXACTLY, StringCondition.IS_NOT_EXACTLY, StringCondition.CONTAINS, StringCondition.DOES_NOT_CONTAIN, StringCondition.STARTS_WITH, StringCondition.ENDS_WITH];
var dateValueConditions = [DateCondition.IS_EXACTLY, DateCondition.IS_NOT_EXACTLY, DateCondition.IS_BEFORE, DateCondition.IS_BEFORE_OR_EQUAL, DateCondition.IS_AFTER, DateCondition.IS_AFTER_OR_EQUAL, DateCondition.IS_NULL, DateCondition.IS_NOT_NULL];
var dateColumnConditions = [DateCondition.IS_EXACTLY, DateCondition.IS_NOT_EXACTLY, DateCondition.IS_BEFORE, DateCondition.IS_BEFORE_OR_EQUAL, DateCondition.IS_AFTER, DateCondition.IS_AFTER_OR_EQUAL];
var booleanValueConditions = [BooleanCondition.IS_TRUE, BooleanCondition.IS_FALSE, BooleanCondition.IS_EQUAL, BooleanCondition.IS_NOT_EQUAL, BooleanCondition.IS_NULL, BooleanCondition.IS_NOT_NULL];
var booleanColumnConditions = [BooleanCondition.IS_EQUAL, BooleanCondition.IS_NOT_EQUAL];
var charValueConditions = [CharCondition.IS_EQUAL, CharCondition.IS_NOT_EQUAL, CharCondition.IS_NULL, CharCondition.IS_NOT_NULL];
var charColumnConditions = [CharCondition.IS_EQUAL, CharCondition.IS_NOT_EQUAL];
function isNumberConditionValid(condition, value, startValue, endValue) {
  if (condition === NumberCondition.IS_NULL || condition === NumberCondition.IS_NOT_NULL) {
    return true;
  }
  if (condition === NumberCondition.IS_BETWEEN && startValue != null && startValue !== '' && !Number.isNaN(Number.parseFloat(startValue)) && endValue != null && endValue !== '' && !Number.isNaN(Number.parseFloat(endValue))) {
    return true;
  }
  if (condition !== NumberCondition.IS_BETWEEN && value !== undefined && value !== '' && !Number.isNaN(Number.parseFloat(value))) {
    return true;
  }
  return false;
}
function ConditionEditor(props) {
  var column = props.column,
    columns = props.columns,
    config = props.config,
    dh = props.dh,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? DEFAULT_CALLBACK : _props$onChange;
  var selectedColumnType = column.type;
  var _useState = useState(selectedColumnType),
    _useState2 = _slicedToArray(_useState, 2),
    prevColumnType = _useState2[0],
    setPrevColumnType = _useState2[1];

  // Encode both condition and RHV mode in a single key: 'value-is-equal' or 'column-is-equal'
  var _useState3 = useState(() => "".concat(typeof config.rightHandValue === 'object' ? COLUMN_PREFIX : VALUE_PREFIX).concat(config.condition)),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedConditionKey = _useState4[0],
    setConditionKey = _useState4[1];
  var selectedCondition = selectedConditionKey.replace(/^(value|column)-/, '');
  var isColumnMode = selectedConditionKey.startsWith(COLUMN_PREFIX);
  var _useState5 = useState(config.rightHandValue),
    _useState6 = _slicedToArray(_useState5, 2),
    conditionValue = _useState6[0],
    setValue = _useState6[1];
  var _useState7 = useState(config.start),
    _useState8 = _slicedToArray(_useState7, 2),
    startValue = _useState8[0],
    setStartValue = _useState8[1];
  var _useState9 = useState(config.end),
    _useState0 = _slicedToArray(_useState9, 2),
    endValue = _useState0[0],
    setEndValue = _useState0[1];
  var _useState1 = useState(true),
    _useState10 = _slicedToArray(_useState1, 2),
    isValid = _useState10[0],
    setIsValid = _useState10[1];
  if (selectedColumnType !== prevColumnType) {
    // Column type changed, reset condition and value fields
    setConditionKey("".concat(VALUE_PREFIX).concat(getDefaultConditionForType(selectedColumnType)));
    setValue(getDefaultValueForType(selectedColumnType));
    setStartValue(undefined);
    setEndValue(undefined);
    setPrevColumnType(selectedColumnType);
  }

  // Build label helper for any condition enum value
  var getConditionLabel = useCallback(condition => {
    if (TableUtils.isNumberType(selectedColumnType)) {
      return getLabelForNumberCondition(condition);
    }
    if (TableUtils.isCharType(selectedColumnType)) {
      return getLabelForCharCondition(condition);
    }
    if (TableUtils.isStringType(selectedColumnType)) {
      return getLabelForStringCondition(condition);
    }
    if (TableUtils.isDateType(selectedColumnType)) {
      return getLabelForDateCondition(condition);
    }
    return getLabelForBooleanCondition(condition);
  }, [selectedColumnType]);
  var _useMemo = useMemo(() => {
      var valueConditions = [];
      var columnConditions = [];
      if (TableUtils.isNumberType(selectedColumnType)) {
        valueConditions = numberValueConditions;
        columnConditions = numberColumnConditions;
      } else if (TableUtils.isCharType(selectedColumnType)) {
        valueConditions = charValueConditions;
        columnConditions = charColumnConditions;
      } else if (TableUtils.isStringType(selectedColumnType)) {
        valueConditions = stringValueConditions;
        columnConditions = stringColumnConditions;
      } else if (TableUtils.isDateType(selectedColumnType)) {
        valueConditions = dateValueConditions;
        columnConditions = dateColumnConditions;
      } else if (TableUtils.isBooleanType(selectedColumnType)) {
        valueConditions = booleanValueConditions;
        columnConditions = booleanColumnConditions;
      }
      return [valueConditions.map(c => /*#__PURE__*/_jsx(Item, {
        children: getConditionLabel(c)
      }, "".concat(VALUE_PREFIX).concat(c))), columnConditions.map(c => /*#__PURE__*/_jsx(Item, {
        children: getConditionLabel(c)
      }, "".concat(COLUMN_PREFIX).concat(c)))];
    }, [selectedColumnType, getConditionLabel]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    pickerValueItems = _useMemo2[0],
    pickerColumnItems = _useMemo2[1];
  var handleConditionKeyChange = useCallback(key => {
    if (key == null) return;
    var keyStr = String(key);
    log.debug('handleConditionKeyChange', keyStr);
    var nextIsColumn = keyStr.startsWith(COLUMN_PREFIX);
    if (nextIsColumn && typeof conditionValue !== 'object') {
      // Switching to column mode — default to first compatible column
      var firstCompatible = columns.find(c => {
        if (TableUtils.isNumberType(selectedColumnType)) {
          return TableUtils.isNumberType(c.type);
        }
        return TableUtils.getNormalizedType(selectedColumnType) === TableUtils.getNormalizedType(c.type);
      });
      setValue(firstCompatible != null ? {
        name: firstCompatible.name,
        type: firstCompatible.type
      } : undefined);
    } else if (!nextIsColumn && typeof conditionValue === 'object') {
      // Switching to value mode — clear the column value
      setValue(getDefaultValueForType(selectedColumnType));
    }
    setConditionKey(keyStr);
  }, [columns, selectedColumnType, conditionValue]);
  var handleRightHandValueChange = useCallback(value => {
    log.debug('handleRightHandValueChange', value);
    setValue(value);
  }, []);
  var handleStartValueChange = useCallback(e => {
    var value = e.target.value;
    log.debug('handleStartValueChange', value);
    setStartValue(value);
  }, []);
  var handleEndValueChange = useCallback(e => {
    var value = e.target.value;
    log.debug('handleEndValueChange', value);
    setEndValue(value);
  }, []);
  useEffect(function changeCondition() {
    var isConditionValid = true;
    if (selectedCondition === undefined) {
      log.debug('Unable to create formatting rule. Condition is not selected.');
      isConditionValid = false;
    } else if (TableUtils.isNumberType(column.type) && (selectedCondition === NumberCondition.IS_BETWEEN || typeof conditionValue !== 'object') && !isNumberConditionValid(selectedCondition, typeof conditionValue === 'string' ? conditionValue : undefined, startValue, endValue)) {
      log.debug('Unable to create formatting rule. Invalid value', conditionValue);
      isConditionValid = false;
    } else if (TableUtils.isDateType(column.type) && typeof conditionValue !== 'object' && !isDateConditionValid(dh, selectedCondition, conditionValue)) {
      log.debug('Unable to create formatting rule. Invalid date condition', conditionValue);
      isConditionValid = false;
    } else if (TableUtils.isCharType(column.type) && typeof conditionValue !== 'object' && selectedCondition !== CharCondition.IS_NULL && selectedCondition !== CharCondition.IS_NOT_NULL && (conditionValue === undefined || conditionValue.length !== 1)) {
      log.debug('Unable to create formatting rule. Char value must be a single character', conditionValue);
      isConditionValid = false;
    } else if (TableUtils.isBooleanType(column.type) && typeof conditionValue !== 'object' && (selectedCondition === BooleanCondition.IS_EQUAL || selectedCondition === BooleanCondition.IS_NOT_EQUAL) && conditionValue !== 'true' && conditionValue !== 'false' && conditionValue !== 'null') {
      log.debug('Unable to create formatting rule. Boolean comparison requires a column, true, false, or null', conditionValue);
      isConditionValid = false;
    }
    setIsValid(isConditionValid);
    onChange({
      condition: selectedCondition,
      rightHandValue: conditionValue,
      start: startValue,
      end: endValue
    }, isConditionValid);
  }, [onChange, column.type, dh, selectedCondition, conditionValue, startValue, endValue]);
  var conditionInputs = useMemo(() => {
    if (selectedColumnType === undefined) {
      // Column not selected
      return null;
    }

    // IS_NULL/IS_NOT_NULL enum values are identical across all types ('is-null' /
    // 'is-not-null'), so checking one enum covers all.
    // Boolean IS_TRUE/IS_FALSE also never need a value input.
    if (selectedCondition === StringCondition.IS_NULL || selectedCondition === StringCondition.IS_NOT_NULL || selectedCondition === BooleanCondition.IS_TRUE || selectedCondition === BooleanCondition.IS_FALSE) {
      return null;
    }

    // A ModelColumn rightHandValue is always valid (column-vs-column comparison).
    // For string values, check type-specific validity.
    var rhvIsColumn = typeof conditionValue === 'object';
    var hasInvalidValue = !rhvIsColumn && !isValid && conditionValue !== undefined && conditionValue !== '';

    // Only offer columns that are type-compatible with the condition column so
    // the generated expression is valid (e.g. prevent startsWith(intColumn)).
    // Numbers are cross-compatible (int vs double). Everything else requires the same
    // normalized type. (Note: text types are not compatible (string vs char)
    var compatibleRhvColumns = columns.filter(c => {
      if (TableUtils.isNumberType(selectedColumnType)) {
        return TableUtils.isNumberType(c.type);
      }
      return TableUtils.getNormalizedType(selectedColumnType) === TableUtils.getNormalizedType(c.type);
    });

    // IS_BETWEEN uses two separate range inputs
    if (TableUtils.isNumberType(selectedColumnType) && selectedCondition === NumberCondition.IS_BETWEEN) {
      var isInvalid = !rhvIsColumn && !isValid && (startValue !== undefined && startValue !== '' || endValue !== undefined && endValue !== '');
      return /*#__PURE__*/_jsxs("div", {
        className: "d-flex flex-row",
        children: [/*#__PURE__*/_jsx("input", {
          type: "number",
          className: classNames('form-control', 'd-flex', 'mr-2', {
            'is-invalid': isInvalid
          }),
          placeholder: "Start value",
          value: startValue !== null && startValue !== void 0 ? startValue : '',
          onChange: handleStartValueChange
        }), /*#__PURE__*/_jsx("input", {
          type: "number",
          className: classNames('form-control', 'd-flex', {
            'is-invalid': isInvalid
          }),
          placeholder: "End value",
          value: endValue !== null && endValue !== void 0 ? endValue : '',
          onChange: handleEndValueChange
        })]
      });
    }
    if (isColumnMode) {
      return /*#__PURE__*/_jsx(ComboBox, {
        "aria-label": "Select a column",
        selectedKey: typeof conditionValue === 'object' ? conditionValue.name : null,
        onChange: key => {
          if (key == null) return;
          var col = compatibleRhvColumns.find(c => c.name === String(key));
          if (col != null) {
            handleRightHandValueChange({
              name: col.name,
              type: col.type
            });
          }
        },
        children: compatibleRhvColumns.map(c => c.name)
      });
    }
    return /*#__PURE__*/_jsx("input", {
      type: TableUtils.isNumberType(selectedColumnType) ? 'number' : 'text',
      className: classNames('form-control', {
        'is-invalid': hasInvalidValue
      }),
      value: typeof conditionValue === 'string' ? conditionValue : '',
      placeholder: "Enter a value",
      onChange: e => handleRightHandValueChange(e.target.value)
    });
  }, [columns, selectedColumnType, selectedCondition, conditionValue, startValue, endValue, isValid, handleRightHandValueChange, handleStartValueChange, handleEndValueChange, isColumnMode]);
  return /*#__PURE__*/_jsxs("div", {
    className: "condition-editor mb-2",
    children: [/*#__PURE__*/_jsxs(Picker, {
      selectedKey: selectedConditionKey,
      "aria-label": "Select condition",
      "data-testid": "condition-select",
      width: "100%",
      UNSAFE_className: "mb-2",
      onChange: handleConditionKeyChange,
      children: [/*#__PURE__*/_jsx(Section, {
        title: "Value",
        children: pickerValueItems
      }), /*#__PURE__*/_jsx(Section, {
        title: "Column",
        children: pickerColumnItems
      })]
    }), conditionInputs]
  });
}
export default ConditionEditor;
//# sourceMappingURL=ConditionEditor.js.map